import { motion } from "framer-motion"
import { Sparkles, MessageSquare } from "lucide-react"
import "./CountryHero.css"

const CountryHero = ({ country, flagUrl, heroImage }) => {
  return (
    <div
      className="country-hero"
      style={{
        backgroundImage: `url(${heroImage})`,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="hero-content"
      >
        <div className="country-flag-title">
          <motion.img
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.5 }}
            src={flagUrl || "https://cdn-icons-png.flaticon.com/128/197/197374.png"}
            alt={`${country} Flag`}
            className="country-flag"
          />
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.5 }}
          >
            Study in {country}
          </motion.h1>
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.5 }}
          className="hero-subtitle"
        >
          Your journey to world-class education starts here. Discover top universities, scholarships, and career opportunities.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.9, duration: 0.5 }}
          className="cta-container"
        >
          <a
            href="https://wa.me/9115400982"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button"
          >
            <MessageSquare className="cta-icon" />
            Talk to an Expert Counsellor for FREE
            <Sparkles className="cta-sparkle" />
          </a>
        </motion.div>
      </motion.div>
    </div>
  )
}

export default CountryHero
